interface AppTitleProps {
  title: string;
  subtitle: string;
  isDarkMode?: boolean;
  hideOnMobile?: boolean;
}

export default function AppTitle({
  title,
  subtitle,
  isDarkMode = false,
  hideOnMobile = false,
}: AppTitleProps) {
  const themeClasses = {
    text: isDarkMode ? "text-white" : "text-gray-900",
    textSecondary: isDarkMode ? "text-gray-400" : "text-gray-500",
  };

  return (
    <div className={`min-w-0 ${hideOnMobile ? "hidden sm:block" : ""}`}>
      <h1 className={`text-lg font-bold ${themeClasses.text} truncate`}>
        {title}
      </h1>
      <p className={`text-xs ${themeClasses.textSecondary} truncate`}>
        {subtitle}
      </p>
    </div>
  );
}
